<template>
  <v-dialog
    v-model="dialog"
    overlay
    persistent
    max-width="400px"
    transition="dialog-transition"
  >
    <template #activator="{ attrs }">
      <v-btn
        :loading="searching"
        @click="OpenPayment"
        v-bind="attrs"
        block
        color="warning darken-3"
        >Cash (OUT)
        <v-icon right>fas fa-hand-holding-usd</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="warning headline white--text"
        >QAAS Withdraw
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-5">
        <v-form v-model="valid" ref="withDrowform">
          <BaseDate
            v-model="PayDate"
            outlined
            :rules="v => !!v || 'Date is required'"
          >
          </BaseDate>
          <v-select
            outlined
            solo
            append-icon="fas fa-search-dollar"
            v-model.trim="cashType"
            :items="GetCashTypes"
            :rules="[v => !!v || 'Cash Type is required']"
            label="Money Type"
            required
            no-data-text="Refresh the page"
          ></v-select>
          <v-select
            @change="CheckBalance"
            :success-messages="AccountBlce > 0 ? Balance : ''"
            :error-messages="
              AccountBlce <= 0 && CashAccount && !searching ? Balance : ''
            "
            outlined
            :loading="searching"
            v-model.trim="CashAccount"
            :rules="[v => !!v || 'Cash Account is required']"
            :items="Cashes"
            item-text="AccountName"
            item-value="_id"
            label="Cash Account"
            prepend-inner-icon="fas fa-hand-holding-usd"
            required
            no-data-text="No Cash Account"
          ></v-select>

          <BaseNumInput
            :rules="[paymentRule]"
            outlined
            v-model.trim="Amount"
            label="Out Amount"
          ></BaseNumInput>

          <v-text-field
            name="InfoFildName"
            label="Details"
            id="InfoFildid"
            outlined
            v-model.trim="Details"
            :rules="[v => !!v || 'Provide Infomation']"
          ></v-text-field>
        </v-form>
        <p v-if="ErrMsg" v-html="ErrMsg" class="text-center error--text"></p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          width="200px"
          :loading="loading"
          @click="OnSavePayment"
          :disabled="!valid"
          color="success"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    AccountNumber: [String],
    BaseURL: { type: String, required: true },
    FinishedWithdrow: [Function],
  },

  data() {
    return {
      ErrMsg: "",
      loading: false,
      searching: false,
      dialog: false,
      valid: false,
      AccountBlce: 0,
      CashAccount: "",
      Cashes: [],
      PayDate: "",
      cashType: "",
      Amount: 0,
      Details: "",
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.$nextTick(() => {
          this.PayDate = this.Current().date;
          // this.Amount = this.DueAmount;
          //   this.Amount = 0;
        });
      }
    },
  },
  computed: {
    ...mapGetters(["UsersToken", "GetCashTypes"]),
    Balance() {
      return `${this.AccountBlce.toLocaleString()} ${this.cashType ||
        this.UsersToken.CashBase}`;
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.ErrMsg = "";
      this.CashAccount = "";
      this.cashType = "";
      this.PayDate = "";
      this.Details = "";
      this.Amount = 0;
      this.AccountBlce = 0;
      this.$refs.withDrowform.resetValidation();
    },
    CheckBalance(selected) {
      this.searching = true;
      this.AccountBlce = 0;
      this.GetReq("/Account/checkBalance", {
        Account: selected,
        cashType: this.cashType,
      })
        .then(({ data }) => {
          if (data.length) this.AccountBlce = data[0].Amount;
          // console.log(val);
          this.searching = false;
          if (this.valid) this.$refs.withDrowform.validate();
        })
        .catch(err => {
          console.log(err);
          this.searching = false;
        });
    },
    GetReq(url, query) {
      if (!url) url = "/Account";
      if (!query) query = { acc: [{ AccountType: 1 }, { AccountType: 3 }] };

      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    OpenPayment() {
      this.searching = true;

      this.GetReq()

        .then(cash => {
          // console.log(blce.data);

          this.dialog = true;
          this.searching = false;
          this.Cashes = cash.data;
        })
        .catch(err => {
          console.log(err);
          this.searching = false;
        });
    },
    OnSavePayment() {
      this.ErrMsg = "";
      if (this.$refs.withDrowform.validate()) {
        let data = {
          Account: this.CashAccount,
          Description: this.AccountNumber,
          cashType: this.cashType,
          Amount: this.Amount,
          Details: this.Details,
          date: this.PayDate,
          time: this.Current().time,
        };
        this.loading = true;
        this.$store
          .dispatch("INSERT_ONLY", { url: this.BaseURL + "/withdraw", data })
          .then(() => {
            // console.log(val);
            this.loading = false;
            this.FinishedWithdrow();
            this.close();
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.ErrMsg = error && error.response && error.response.data;
          });
      }
    },
    paymentRule(v) {
      //   v = v.replace(/,/g, "");
      let andCon =
        v && v.replace(/,/g, "") > 0 && v.replace(/,/g, "") <= this.AccountBlce;
      return andCon || "Invalid Amount";
    },
  },
};
</script>
